import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
export default new Router({
	mode: "history",
	scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
			return {
				selector: to.hash,
			};
		} else {
			return {
				x: 0,
				y: 0,
			};
		}
	},
	routes: [
		{
			path: "/",
			name: "Index",
			component: resolve => require(["@/views/User/Dashboard"], resolve),
			meta: {
				requireLogin: true,
				menuIndex: "User-Dashboard",
			},
		},
		{
			path: "/user/login",
			name: "Login",
			component: resolve => require(["@/views/User/Login"], resolve),
			meta: {
				requireLogin: false,
				noMenu: true,
			},
		},
		{
			path: "/user/dashboard",
			name: "User-Dashboard",
			component: resolve => require(["@/views/User/Dashboard"], resolve),
			meta: {
				requireLogin: true,
				menuIndex: "User-Dashboard",
			},
		},
		{
			path: "/user/setting",
			name: "User-Setting",
			component: resolve => require(["@/views/User/Setting"], resolve),
			meta: {
				requireLogin: true,
				menuIndex: "User-Setting",
			},
		},
		{
			path: "/active/index",
			name: "Active-Index",
			component: resolve => require(["@/views/Active/Index"], resolve),
			meta: {
				requireLogin: true,
				menuIndex: "Active-Index",
			},
		},
		{
			path: "/active/edit/:id/:tab?",
			name: "Active-Edit",
			component: resolve => require(["@/views/Active/Edit"], resolve),
			meta: {
				requireLogin: true,
				menuIndex: "Active-Index",
			},
		},
		{
			path: "/active/info/:id/:tab?",
			name: "Active-Info",
			component: resolve => require(["@/views/Active/Info"], resolve),
			meta: {
				requireLogin: true,
				menuIndex: "Active-Index",
			},
		},
		{
			path: "/setting/model/:tab?",
			name: "Setting-Model",
			component: resolve => require(["@/views/Setting/Model"], resolve),
			meta: {
				requireLogin: true,
				menuIndex: "Setting-Model",
			},
		},
		{
			path: "/setting/config",
			name: "Config-Config",
			component: resolve => require(["@/views/Setting/Config"], resolve),
			meta: {
				requireLogin: true,
				menuIndex: "Config-Config",
			},
		},
		{
			path: "/setting/store",
			name: "Setting-Store",
			component: resolve => require(["@/views/Setting/Store"], resolve),
			meta: {
				requireLogin: true,
				menuIndex: "Setting-Store",
			},
		},
		{
			path: "/setting/admin",
			name: "Config-Admin",
			component: resolve => require(["@/views/Setting/Admin"], resolve),
			meta: {
				requireLogin: true,
				menuIndex: "Config-Admin",
			},
		},

		{
			path: "/customer/user",
			name: "Customer-User",
			component: resolve => require(["@/views/Customer/User"], resolve),
			meta: {
				requireLogin: true,
				menuIndex: "Customer-User",
			},
		},
		{
			path: "/customer/user/info/:id/:tab?",
			name: "Customer-User-Show",
			component: resolve => require(["@/views/Customer/UserInfo"], resolve),
			meta: {
				requireLogin: true,
				menuIndex: "Customer-User-Info",
			},
		},
	],
});
